module.exports = __webpack_public_path__ + "img/avatar.99714f1d.jpg";